import * as React from 'react'
import { saTypeSaImage } from "../saTypes"

// @ts-ignore
import { saImg } from './saImage.module.css'
import { GatsbyImage, getImage } from "gatsby-plugin-image"


const SaImage:React.FC<saTypeSaImage> = ({ ...props }) => {

  if (!props || !props.sourceUrl){
    //console.log('saError: Image not found')
    //console.log(props)
    return (<>saError: Image not found</>)
  }


  if (props && props.localFile) return (
    <>
      <GatsbyImage image={getImage(props.localFile)} alt={''} />
    </>
  )

  if (props && props.sourceUrl) return (
    <img
      className={saImg}
      src={props.sourceUrl}
      alt=""
    />
  )

}

export default SaImage

